<template>
    <div class="error-container">
        <img class="error-icon" src="./image.png" alt="error-icon" />
        <div class="error-title">{{ $t('message.error.errorTitle') }}</div>
        <div class="error-desc" v-html="message || ($t('message.error.brokenLinkMessage') + '<br />' + $t('message.error.contactMerchantMessage'))">
        </div>
    </div>
</template>

<script>
export default {
  name: 'ErrorPage',
  props: {
    message: {
      type: String,
      default: '',
    },
  },
};
</script>

<style scoped>
.error-container {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background: #F9FAFB;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    z-index: 9999;
}

.error-icon {
    width: 40px;
    height: 40px;
    margin-bottom: 32px;
    padding: 4px;
    margin-bottom: 16px;
}

.error-title {
    color: #1A202C;
    margin-bottom: 16px;
    font-family: Open Sans bold;
    font-size: 24px;
    line-height: 30px;
    letter-spacing: 0px;
    text-align: center;
    font-weight: 700;
}

.error-desc {
    color: #23272e;
    text-align: center;
    font-family: Open Sans regular;
    font-weight: 400;
    font-size: 14px;
    line-height: 18px;
    letter-spacing: 0px;
    text-align: center;
    color: rgba(26, 32, 44, 1);
    width: 800px;
}
</style>
